import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import React, { useState } from "react";
import Image from "next/image";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import Apple from "../assets/icons/apple";
import GooglePlay from "../assets/icons/googleplay";
// import { DirectPaths } from "@/config/routes";
import dynamic from "next/dynamic";
// import { ProductType } from "@/app/utils/constants";

const GetICMAppModal = dynamic(() => import("./get-icm-app-modal"), { ssr: false });

interface HeroSectionProps {
    description: string;
    btn1Label: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({ description, btn1Label }) => {
    const [showAppModal, setShowAppModal] = useState<boolean>(false);

    const toggleDownloadApp = () => {
        setShowAppModal(!showAppModal);
    };

    return (
        <div className="flex flex-col items-center justify-between md:h-[524px] md:flex-row md:pt-12">
            <div className="w-full flex-1">
                <div className="visible mt-[36px] flex flex-1 justify-center p-6 md:hidden">
                    <Image
                        src={`${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/HeroImage-Unlisted-mob.webp`}
                        alt="Hero Image"
                        width={650}
                        height={534}
                        priority
                        fetchPriority="high"
                        sizes="(max-width: 768px) 100vw, 650px"
                    />
                </div>
                <div className="flex-1">
                    <h1 className="max-w-[540px] text-center text-3xl font-semibold leading-[140%] tracking-[-0.5px] md:text-left md:text-5xl md:leading-[130%] md:tracking-[-0.5px] px-2 md:px-0">
                        Go Beyond the Listed Markets With Unlisted Shares
                    </h1>
                    <p className="mt-4 max-w-[600px] text-center text-xl md:text-left">
                        {description}
                    </p>
                </div>
                <div className="mb-8 mt-10 flex flex-col md:flex-row md:gap-s6">
                    <RegularButton
                        noIcon
                        showRightIcon={false}
                        size={ButtonSize.Large}
                        variant={ButtonVariant.PrimaryDefault}
                        label={btn1Label}
                        className="mb-2 w-full max-w-full md:mb-0 md:max-w-fit"
                        onClick={() => {
                            setAnalyticsEvent(`/login`, "Home_Get_Started_Fold1");
                            window.location.href = `/login`; /* ?product=${ProductType.UNLISTED_EQUITY */
                        }}
                    />
                    <RegularButton
                        id="download-app-button"
                        noIcon
                        showRightIcon={true}
                        rightIcon={
                            <div className="flex h-12 min-w-16 items-center justify-center gap-s4">
                                <Apple className="h-10 w-10 text-black" />
                                <div className="h-full w-[3px] bg-neutralOpacityDark-20"></div>
                                <GooglePlay className="h-10 w-10 text-black" />
                                <div className="absolute -top-[14px] right-7 rounded-full border border-orange-500 bg-orange-100 px-4 py-1 text-xs">
                                    Coming soon
                                </div>
                            </div>
                        }
                        size={ButtonSize.Large}
                        variant={ButtonVariant.SecondaryDefault}
                        label="Download the App"
                        className="relative mt-4 w-full max-w-full cursor-auto sm:mt-0 md:w-auto"
                        onClick={() => {
                            // setAnalyticsEvent(`${DirectPaths.HOME}`, "Home_Explore_Broking_Fold2");
                            // toggleDownloadApp();
                        }}
                    />
                </div>
            </div>
            <div className="relative mt-[36px] hidden flex-1 justify-end md:visible md:flex">
                <Image
                    src={`${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/HeroImage-Unlisted.webp`}
                    alt="Hero Image"
                    width={650}
                    height={584}
                    priority
                    fetchPriority="high"
                    sizes="(max-width: 768px) 100vw, 650px"
                />
            </div>
            {showAppModal && <GetICMAppModal open={showAppModal} onClose={toggleDownloadApp} />}
        </div>
    );
};

export default HeroSection;
